module.exports = __webpack_public_path__ + "static/img/wealth_level_86.9b64d3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_86.png
// module id = 8uZt
// module chunks = 0